<template>
    <div class="aup-base-photo-card position-relative w-100"
        :class="{'aup-base-photo-card--external': communityGalleryView }">
        <img
			class="w-100"
			:src="resolveMediaImageURL(imageURL, imageZestyGuid, 1400)"
			:alt="alt || ''"
			@error="onRespImageError($event, 1400)"
		/>
        <div
            class="p-3 position-absolute aup-base-photo-card__overlay w-100 h-100"
            @click="$emit('cardOverlayClicked')"
        >
            <div
                class="aup-base-photo-card__overlay__content-wrapper d-flex flex-column justify-content-between h-100"
            >
                <!--ROW 1: PHOTO TITLE AND LIKES : PUBLIC PROFILE / GALLERY VIEW -->
                <div class="d-flex justify-content-between aup-base-photo-card__overlay__row" :class="communityGalleryView ? 'flex-column' : ' align-items-center' ">

                    <div v-if="title" :class="{ 'mb-2 mb-lg-3' : communityGalleryView }">
                        <p class="text-white t-heavy mb-0">error:call:31</p>
                    </div>

					<!-- COMMUNITY GALLERY VIEW -->
					<div v-if="communityGalleryView">
                        <div v-if="verifiedSonyPhoto && cameraMake && cameraModel" class="mb-2">
                            <p class="t-micro text-white text-white-light text-uppercase mb-0">Camera</p>
                            <p
                                class="aup-base-photo-card__overlay__row--gear--camera text-white t-regular mb-0"
                            >error:call:32 error:call:33</p>
                        </div>
                        <div v-if="verifiedSonyPhoto && lensModel">
                            <p class="t-micro text-uppercase text-white text-white-light mb-0">Lens</p>
                            <p
                                class="aup-base-photo-card__overlay__row--gear--lens text-white t-regular mb-0"
                            >error:call:34</p>
                        </div>
                    </div>

					<!-- LIKE BUTTON ON PUBLIC PROFILE VIEW -->
                    <div class="d-flex align-items-center" v-if="!communityGalleryView && showLikes">
						<BaseLikeButton
							:isSelf="isSelfProfile"
							:likedContent="imageGUID"
							:isLiked="isLiked"
							:likeCount="photoLikes"
							:likeType="'media'"
							textPlacement="left"
							:showCount="true"
							:profileView="true"
							:loggedIn="loggedIn"
							:showCountOnHover="false"
						/>
                    </div>
                </div>

                <!--ROW 2: CAMERA AND LENS - PUBLIC PROFILE VIEW -->
                <div
                    class="aup-base-photo-card__overlay__row aup-base-photo-card__overlay__row--gear d-flex justify-content-between"
					v-if="!communityGalleryView"
                >
                    <div>
                        <div v-if="verifiedSonyPhoto && cameraMake && cameraModel">
                            <p class="t-micro text-white text-white-light text-uppercase">Camera</p>
                            <p
                                class="aup-base-photo-card__overlay__row--gear--camera text-white t-regular"
                            >error:call:35 error:call:36</p>
                        </div>
                        <div v-if="verifiedSonyPhoto && lensModel">
                            <p class="t-micro text-uppercase text-white text-white-light">Lens</p>
                            <p
                                class="aup-base-photo-card__overlay__row--gear--lens text-white t-regular"
                            >error:call:37</p>
                        </div>
                    </div>
                    <div v-if="verifiedSonyPhoto"  class="align-self-end">
                        <IconAlphaVerify
                            aria-label="Image to indicate image taken with Sony gear"
                            class=""
                        />
                    </div>
                </div>


                <!--FOOTER ROW: Conditionally show -- community gallery view -->
                <div
                    v-if="communityGalleryView"
                    class="aup-base-photo-card__overlay-footer d-flex align-items-center justify-content-between"
                    @click.stop="handler"
                >
                    <a :href="profileURL" class="aup-base-photo-card__profile-link">
                        <figure class="mb-0 aup-base-photo-card__avatar-wrapper">
                            <img
								:src="renderedDisplayPic || this.calcRespImageURL(profileAvatarGuid, 100)"
                                class="aup-base-photo-card__avatar"
                                v-if="renderedDisplayPic ||profileAvatarGuid"
								alt="Profile image"
                            />
                        </figure>
                        <p
                            class="t-micro t-shadow text-uppercase m-0 ml-2 aup-base-photo-card__profile-link-text"
                            v-if="userName"
                        >error:call:38</p>
                    </a>
                    <div class="d-flex align-items-center">
                        <IconAlphaVerify v-if="verifiedSonyPhoto" class="aup-base-photo-card__svg-badge" />
                        <BaseLikeButton
                            v-if="showLikes"
                            :isSelf="isSelfProfile"
                            :likedContent="imageGUID"
                            :isLiked="isLiked"
                            :likeCount="photoLikes || 0"
                            :likeType="'media'"
                            textPlacement="top"
                            :showCount="false"
                            :profileView="false"
                            :loggedIn="loggedIn"
                            :showCountOnHover="true"
                        />
                    </div>
                </div>
            </div>

            <!--expand icon centered : non gallery view-->
            <div class="aup-base-photo-card__expand-icon-container  position-absolute" v-if="!communityGalleryView">
                <IconExpand
                    class="aup-base-photo-card__svg"
                    role="button"
                    aria-label="Button to expand image"
                    :height="24"
                    :width="24"
                />
            </div>

			<!--expand icon : gallery view -->
            <div
				v-if="communityGalleryView"
				class="aup-base-photo-card__expand-icon-container aup-base-photo-card__expand-icon-container--gallery pr-3 pt-3 position-absolute"
			>
                <IconExpand
                    class="aup-base-photo-card__svg"
                    role="button"
                    aria-label="Button to expand image"
                    :height="24"
                    :width="24"
                />
            </div>

        </div>
    </div>
</template>
<script>
import { API_GET_LEAN_PROFILE } from '@/api-service.js';
import { mapState } from 'vuex';
import BaseLikeButton from '@/components/global/BaseLikeButton';
import { PROFILE_CONSTANTS } from '@/PROFILE_CONSTANTS';
import { calcRespImageURLMixin } from '@/mixins/mixins.js';


export default {
	name: 'BasePhotoCard',
    components: {
        BaseLikeButton
	},
	mixins: [ calcRespImageURLMixin ],
	data() {
		return {
			clicked: 0,
			profilePhotoURL: this.userDisplayPic || '',
            profileAvatarGuid: '',
            baseProfileURL: PROFILE_CONSTANTS.PROFILE_URL,
            profileURL: '',

		};
    },
    computed: {},
	created: async function() {

		if (this.profilePhotoURL.length) {
			const userData = await API_GET_LEAN_PROFILE(this.profilePhotoURL);
			if (userData !== undefined) {
                // this.profileURL = this.baseProfileURL + userData.data.profile.ppd_profileurl + '/';
				const profileURLRaw = userData.data.profile.ppd_profileurl;
				this.profileURL = (profileURLRaw.startsWith("http://") || profileURLRaw.startsWith("https://"))
					? profileURLRaw
					: this.baseProfileURL + profileURLRaw + '/';

				userData.data.images.forEach(item => {
					if (item.ppd_isprofile) {
                        this.profileAvatarGuid = item.ppd_zestyguid;
					}
				});
            }
		} else if ( this.userSlug ) {
            // this.profileURL = this.baseProfileURL + this.userSlug + '/';
			const profileURLRaw = this.userSlug;
			this.profileURL = (profileURLRaw.startsWith("http://") || profileURLRaw.startsWith("https://"))
				? profileURLRaw
				: this.baseProfileURL + profileURLRaw + '/';

            const userData = await API_GET_LEAN_PROFILE(this.userSlug);
			if (userData !== undefined) {
				userData.data.images.forEach(item => {
					if (item.ppd_isprofile) {
                        this.profileAvatarGuid = item.ppd_zestyguid;
					}
				});
            }
        } else {
            return '';
        }
    },
	props: {
		title: {
			type: String,
			default: null,
		},
		userName: {
			type: String,
			required: false,
        },
        userSlug: {
            type: String,
            required: false
        },
		staffPick: {
			type: Boolean,
			default: false,
		},
		photoLikes: {
			type: Number,
			required: false,
        },
		userDisplayPic: {
			type: String,
			required: false,
        },
        renderedDisplayPic: {
            type: String,
        },
		cameraMake: {
			type: String,
			default: null,
		},
		cameraModel: {
			type: String,
			default: null,
		},
		lensModel: {
			type: String,
			default: null,
		},
		imageZestyGuid: {
			type: String,
			default: null,
		},
		// Preferred when present (CDN/S3). Falls back to /media/fetch/:zestyguid.
		imageURL: {
			type: String,
			default: null,
		},
		verifiedSonyPhoto: {
			type: Boolean,
			default: false,
		},
		communityGalleryView: {
			type: Boolean,
			default: false,
		},
		sonyCamera: {
			type: Boolean,
			default: true,
		},
		sonyLense: {
			type: Boolean,
			default: true,
		},
		imageGUID: {
			type: String,
			default: null,
		},
		alt: {
			type: String,
			default: null,
        },
        isLiked: {
            type: Boolean,
            default: false,
        },
		loggedIn: {
			type: Boolean,
			default: false,
		},
		isSelfProfile: {
			type: Boolean,
			default: false,
        },
        showLikes: {
            type: Boolean,
            default: true,
        },
		equipment: {
			type: Object,
			default: () => {}
		},
    },
    methods: {
        handler() {},

        getCameraNameByModel(model) {
            if (this.equipment.SONY_CAMERAS === undefined || this.equipment.CANON_CAMERAS === undefined) {
                return model;
            }
            const cameras = [...this.equipment.SONY_CAMERAS, ...this.equipment.CANON_CAMERAS];
            const camera = cameras.find(camera => camera.model.toLowerCase() === model.toLowerCase());
            return camera ? camera.name : model;
        },

        getLensNameByModel(model) {
            if (this.equipment.SONY_LENSES === undefined) {
                return model;
            }
            const lenses = this.equipment.SONY_LENSES;
            const lens = lenses.find(lens => lens.model.toLowerCase() === model.toLowerCase());
            return lens ? lens.name : model;
        }
    }
};
</script>

<style lang="scss">
@import '../../assets/scss/all.scss';
.aup-base-photo-card {
	max-width: 700px;
    //min-height: 200px;
    background-color: rgba(0, 0, 0, 0.4);
    cursor: pointer;
	overflow: hidden;

	img {
		display: block;
	}

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 100px;
        width: 100%;
        background: linear-gradient(
            to top,
            hsla(252, 100%, 2.94%, 0.6) 0%,
            hsla(252, 100%, 2.94%, 0.592) 9.6%,
            hsla(252, 100%, 2.94%, 0.571) 17.9%,
            hsla(252, 100%, 2.94%, 0.538) 25.1%,
            hsla(252, 100%, 2.94%, 0.495) 31.3%,
            hsla(252, 100%, 2.94%, 0.444) 36.8%,
            hsla(252, 100%, 2.94%, 0.389) 41.8%,
            hsla(252, 100%, 2.94%, 0.33) 46.6%,
            hsla(252, 100%, 2.94%, 0.27) 51.2%,
            hsla(252, 100%, 2.94%, 0.211) 56%,
            hsla(252, 100%, 2.94%, 0.156) 61.2%,
            hsla(252, 100%, 2.94%, 0.105) 66.9%,
            hsla(252, 100%, 2.94%, 0.062) 73.5%,
            hsla(252, 100%, 2.94%, 0.029) 81%,
            hsla(252, 100%, 2.94%, 0.008) 89.8%,
            hsla(252, 100%, 2.94%, 0) 100%
        );
        /*https://larsenwork.com/easing-gradients/#editor - gradients with easing to smooth edges*/
    }

	&:hover {
		.aup-base-photo-card__overlay__row {
			opacity: 1;
		}
		.aup-base-photo-card__overlay {
			background-color: rgba(0, 0, 0, 0.7);
		}
		.aup-base-photo-card__expand-icon-container {
			opacity: 1;
		}
	}
	&__overlay {
		top: 0;
		right: 0;
		z-index: map-get($zindices, dropdown);
		transition: background-color ease-in 0.25s;
		&__row {
			opacity: 0;
			transition: opacity ease-in 0.35s;
			&--user {
				z-index: map-get($zindices, sticky);
				left: 1rem;
				opacity: 1;
			}
			&--gear {
				p {
					margin-bottom: 0.1rem;
				}
				.text-white-light {
					opacity: 0.5;
				}
				&--camera {
					font-size: 15px;
				}
				&--lens {
					font-size: 15px;
				}
			}
		}
		.svg-primary {
			path {
				fill: $primary;
			}
		}
	}

    &__overlay-footer {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 24px;
        pointer-event: none;
        cursor: default;
    }

	&__svg-badge {
		margin-right: 0.75rem;
		display: inline-flex;
		align-items: center;
	}
    &__like-button {
        cursor: pointer;
        &--active {
            path {
                fill: $primary;
            }
        }
    }
    &__avatar-wrapper {
        height: 4rem;
        width: 4rem;

        &--large {
            height: 6rem;
            width: 6rem;
            min-width: 6rem;
            min-height: 6rem;
        }
    }
	&__avatar {
        max-width: 100%;
        width: 100%;
        height: 100%;
		object-fit: cover;
        background-size: 100%;
        border: 2px solid $white;
        border-radius: 50%;
        transition: border-color 0.25s ease-in-out;
		@include animation('fade-in 1s');
    }
    &__profile-link-text {
        color: $white;
        display: inline-block;
        transition: color 0.25s ease-in-out;

        &--dark {
            color: $black;
        }
    }
    &__profile-link {
        display: flex;
        align-items: center;
        padding-right: 12px;
        box-sizing: border-box;

        &:hover {
            cursor: pointer;
            text-decoration: none;

            .aup-base-photo-card__profile-link-text{
                color: $primary;
                text-decoration: underline;
            }

            .aup-base-photo-card__avatar {
                border-color: $primary;
            }
        }
    }
	&__expand-icon-container {
		top: calc(50%);
		left: calc(50%);
		opacity: 0;
		transition: opacity ease-in 0.35s;
		&--gallery {
			top: 0;
			right: 0;
			left: initial;
		}
	}
	@include keyframes(fade-in) {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
}
</style>
